<div
  class="lt-select"
  [class.lt-select--focused]="isFocused()"
  [class.lt-select--filled]="hasValue()"
  [class.lt-select--error]="hasError()"
  [class.lt-select--disabled]="disabled()"
  [class.lt-select--placeholder-mode]="!hasLabel()"
>
  <lt-icon
    class="lt-select__chevron"
    [name]="isFocused() ? 'fa-sharp-solid-chevron-up' : 'fa-sharp-solid-chevron-down'"
  />
  <select
    class="lt-select__field"
    [id]="selectId"
    [disabled]="disabled()"
    [attr.data-testid]="testId()"
    (change)="onChange($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
  >
    <option value="" [selected]="!hasValue()" disabled hidden>{{ placeholder() }}</option>
    @for (option of options(); track option.value) {
      <option [value]="option.value" [selected]="option.value === value()">
        {{ option.label | ltTranslate }}
      </option>
    }
  </select>
  @if (hasLabel()) {
    <label class="lt-select__label" [class.lt-select__label--required]="required()" [for]="selectId">
      {{ label() }}
    </label>
  }
</div>

@if (hasError()) {
  <div class="lt-select__error">
    {{ error() }}
  </div>
}
